module.exports = __webpack_public_path__ + "img/8.4b84f032.png";